import { createSlice } from "@reduxjs/toolkit";

import {
  fetchBooks,
  saveBookThunk,
  fetchBookChapters,
  saveBookChapterThunk,
} from "./book.thunk";

const initialState = {
  books: [],
  chapters: [],
  loading: false,
  error: null,
};

const bookSlice = createSlice({
  name: "book",

  initialState,

  reducers: {
    clearBooks: (state) => {
      state.books = [];
    },

    clearBookChapters: (state) => {
      state.chapters = [];
    },

    clearBookData: (state) => {
      state.books = [];
      state.chapters = [];
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ============================================================
         FETCH BOOKS
      ============================================================ */

      .addCase(fetchBooks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchBooks.fulfilled, (state, action) => {
        state.loading = false;
        state.books = action.payload.data || [];
      })

      .addCase(fetchBooks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.books = [];
      })

      /* ============================================================
         SAVE / UPDATE BOOK
      ============================================================ */

      .addCase(saveBookThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(saveBookThunk.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(saveBookThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ============================================================
         FETCH BOOK CHAPTERS
      ============================================================ */

      .addCase(fetchBookChapters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchBookChapters.fulfilled, (state, action) => {
        state.loading = false;
        state.chapters = action.payload.data || [];
      })

      .addCase(fetchBookChapters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.chapters = [];
      })

      /* ============================================================
         SAVE / UPDATE BOOK CHAPTER
      ============================================================ */

      .addCase(saveBookChapterThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(saveBookChapterThunk.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(saveBookChapterThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  clearBooks,
  clearBookChapters,
  clearBookData,
} = bookSlice.actions;

export default bookSlice.reducer;